var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fb-comments",attrs:{"data-colorscheme":_vm.colorsheme,"data-mobile":_vm.mobile,"data-href":_vm.url,"data-numposts":_vm.numposts,"data-order-by":_vm.orderBy}})}
var staticRenderFns = []

export { render, staticRenderFns }